import { render } from "./TableDiv.vue?vue&type=template&id=6f74860e&scoped=true&ts=true"
import script from "./TableDiv.vue?vue&type=script&lang=ts"
export * from "./TableDiv.vue?vue&type=script&lang=ts"

import "./TableDiv.vue?vue&type=style&index=0&id=6f74860e&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f74860e"]])

export default __exports__